import * as React from "react";
import FontAwesomeIcon from "modules/shared/components/icon/font-awesome-icon";
import MUIAlert from "@mui/material/Alert";
import COLORS from "theme/tokens/colors";

const SuccessIcon = (
  <FontAwesomeIcon
    name="fas fa-check-circle"
    color={COLORS.CONTEXT_SUCCESS_200}
  />
);

const ErrorIcon = (
  <FontAwesomeIcon
    name="far fa-times-circle"
    color={COLORS.CONTEXT_DANGER_200}
  />
);

const ALERT_TYPES_CONFIG = {
  success: {
    icon: SuccessIcon,
  },
  error: {
    icon: ErrorIcon,
  },
};

export default function Alert({ type = "success", children }) {
  const Icon = ALERT_TYPES_CONFIG[type].icon;
  return (
    <MUIAlert severity={type} icon={Icon}>
      {children}
    </MUIAlert>
  );
}
